import { apiClient } from './api';

export interface PaymentMethodsSettings {
  payment_methods: {
    cod: boolean;
    prepaid: boolean;
  };
  shipping_methods: {
    cash_on_delivery: boolean;
    standard: boolean;
    advance_payment: boolean;
  };
  delivery_methods: {
    courier: boolean;
    self_delivery: boolean;
    pickup: boolean;
  };
}

export interface SystemSetting {
  id: number;
  key: string;
  value: string | null;
  description: string | null;
  is_active: boolean;
  created_at: string;
  updated_at?: string;
}

export interface SystemSettingUpdate {
  value?: string | null;
  description?: string | null;
  is_active?: boolean;
}

/**
 * System Settings API Service
 */
export const systemSettingsApi = {
  /**
   * Get payment, shipping, and delivery method settings for checkout
   * Public endpoint - no authentication required
   */
  getPaymentMethodsSettings: () =>
    apiClient.get<PaymentMethodsSettings>('/system-settings/payment-methods'),

  /**
   * Get all system settings (admin only)
   */
  getAllSettings: () =>
    apiClient.get<SystemSetting[]>('/system-settings/'),

  /**
   * Update a system setting by ID (admin only)
   */
  updateSetting: (settingId: number, data: SystemSettingUpdate) =>
    apiClient.put<SystemSetting>(`/system-settings/${settingId}`, data),

  /**
   * Update a system setting by key (admin only)
   */
  updateSettingByKey: (key: string, data: SystemSettingUpdate) =>
    apiClient.put<SystemSetting>(`/system-settings/key/${key}`, data),
};
